module.exports = __webpack_public_path__ + "img/call-light.df781c0a.svg";